// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-job_posting_label {\n  color: black !important;\n  padding: 0px 10px !important;\n}\n.required-icon {\n  color: #ff766e;\n  margin-right: 4px;\n}\n.b-tooltipZ{\n  z-index: 100;\n}\n", ""]);
// Exports
module.exports = exports;
